import styled from "styled-components";
import { getTheme, logger, } from "@bracket/ui";


import type { ColorDeclaration, CSSSpaceDeclaration, CssSpaceValue, FlexAlignment, Strata, } from "@bracket/ui/types";
import { getStrataBackgroundColor, } from "./strata";
import { strataLevels, } from "../../types";

/** Div
 * @summary { box-sizing: border-box } */
export const Div = styled.div<{ $debug?: boolean; }>`
	box-sizing: border-box;
	${({ $debug, }) => $debug && `border: 1px solid red!important;`}
`;


/** 
 * @summary { box-sizing: border-box, display: flex }
 * @arguments $flexible - whether to apply flex: 1 to the box
 * @prop $flow|$direction - the flex-direction of the box, either "stream"/"horizontal" (row) or "stack"/"vertical" (columnar)
*/
export const Box = styled(Div)<{
	$flexible?: boolean;
	$flow?: "horizontal" | "stream" | "stack" | "vertical";
	$direction?: "row" | "horizontal" | "stream" | "stack" | "vertical" | "column";
	$align?: FlexAlignment;
	$justify?: FlexAlignment;
	$maxHeight?: boolean;
	$maxWidth?: boolean;
	$gap?: CSSSpaceDeclaration;
	$strata?: "lowest" | "low" | "default" | "high" | "highest";
}>`
	display: flex;
	${({ $flexible, }) => $flexible && `flex: 1;`}
	${({ $flow, }) => $flow ? ["stream", "horizontal"].includes($flow) ? `flex-direction: row;` : ["stack", "vertical"].includes($flow) ? `flex-direction: column;` : raise(`unknown $flow "${$flow}"`) : ""}
	${({ $direction, }) => 
				( $direction && ["stream", "horizontal", "row"].includes($direction) && `flex-direction: row;` )
		||	( $direction && ["stack", "vertical", "column"].includes($direction) && `flex-direction: column;` )
		||	( $direction && raise(`unknown $direction "${$direction}"`) )
	}
	${({ $align }) => $align && `align-items: ${$align};`}
	${({ $justify, }) => $justify && `justify-content: ${$justify};`}
	${({ $maxHeight }) => $maxHeight && `height: 100%;`}
	${({ $maxWidth }) => $maxWidth && `width: 100%;`}
	${({ $gap }) => $gap && `gap: ${$gap};`}
	// ${({ $strata }) => $strata !== undefined && $strata !== "default" && `z-index: ${strataLevels[$strata]};`}
	${({ $strata }) => $strata !== undefined && $strata !== "default" && `background: ${getStrataBackgroundColor($strata)};`}
`;



/** Inherited Flow -- CSS Flexbox will elect the opposite of it's parent, thus if a child of a VBOX/Flow a HBOX/Stream will be selected, and vice versa. */
export const FlexBox = styled(Box).attrs({ $flexible: true, })``;


/** Vertical/Stacking flow */
export const Flow = styled(Box).attrs({ $flow: "stack", })``;
export const VBox = Flow;


/** Horizontal/Streaming flow */
export const Stream = styled(Flow).attrs({ $flow: "stream", })``;
export const HBox = Stream;


/** Horizontal/Streaming Flow with { flex: 1 } preset */
export const FlexStream = styled(Stream).attrs({ $flexible: true, })``;
export const FlexedHBox = FlexStream;

/** Vertical/Streaming Flow with { flex: 1 } preset */
export const FlexFlow = styled(Flow).attrs({ $flexible: true, })``;
export const FlexedVBox = FlexFlow;


const strataBackground = (strata: Strata): ColorDeclaration => {
	switch (strata) {
		case "lowest": return getTheme().surface_container_lowest;
		case "low": return getTheme().surface_container_low;
		case "default": return getTheme().surface_container;
		case "high": return getTheme().surface_container_high;
		case "highest": return getTheme().surface_container_highest;
		default: return getTheme().error;
	}
}



/** warns to the console something is wrong and returns a void declaration (empty string) to the styled component */
const raise = ( message: string, ): string => {
    logger.warn(`Bracket UI Spacial Node warning: ${message}`);
    return "";
}
